<template>
  <div class="ma-2">
    <div class="text-h4 mb-4">EyeDock Features</div>
    Hello colleagues!
    <div class="my-4">
      EyeDock has been my passion project for more than 20 years. It started off
      as a searchable contact lens database, but I've added so, so much more to
      it over the years. It's hard to summarize all of EyeDock's features but,
      since that is the purpose of this page, I'm going to try.
    </div>
    <v-container class="">
      <v-row>
        <v-col
          cols="12"
          sm="6"
          v-for="(section, index) in data"
          :key="index"
          class=""
        >
          <v-card style="height: 100%" rounded>
            <div class="title text-center cardTitle">{{ section.label }}</div>
            <!-- <v-divider class="mt-2 mb-4"></v-divider> -->
            <table class="ma-4">
              <tr>
                <th>Component</th>
                <th>Free</th>
                <th>Pro Feature</th>
                <th>Info</th>
              </tr>
              <tr v-for="(row, i) in section.items" :key="i">
                <td>
                  {{ row.label }}
                </td>
                <td class="text-center" :class="{ 'pt-4': row.header }">
                  <v-icon
                    v-if="!row.header && row.permission != 'pro'"
                    color="green"
                    >mdi-check</v-icon
                  >
                  <v-icon v-if="row.permission == 'pro'" color="red"
                    >mdi-close</v-icon
                  >
                </td>
                <td class="text-center" :class="{ 'pt-4': row.header }">
                  <v-icon color="green" v-if="!row.header">mdi-check</v-icon>
                </td>
                <td :class="{ 'pt-4': row.header }">
                  <span v-if="row.more">{{ row.more }}</span>
                </td>
              </tr>
            </table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "AboutEyedock",
  props: {},
  data: function () {
    return {
      data: [
        {
          header: true,
          label: "Contact Lens Searches",
          more: "link",
          items: [
            { label: "Searching by lens name" },
            { label: "Searching by lens company" },
            { label: "Searching by lens types", more: "link" },
            { label: "Price estimations", more: "link" },
            { label: "Online prices", permission: "pro", more: "link" },
            { label: "Searching by refraction", permission: "pro" },
            { label: "Trial lens suggestions", permission: "pro" },
            { label: "Contact lens comparisons", permission: "pro" },
          ],
        },
        {
          header: true,
          label: "Medication Searches",
          items: [
            { label: "Topical ophthalmics, Rx & OTC" },
            { label: "Select oral meds" },
            { label: "Searching by generic drug" },
            { label: "Searching by brand name drug" },
          ],
        },
        {
          header: true,
          label: "ICD 10 Codes",
          items: [
            { label: "Search nearly 70,000 ICD 10 codes" },
            { label: "Diabetic retinopathy coding widget" },
          ],
        },
        {
          header: true,
          label: "Tools and Utilities",
          items: [
            { label: "Plaquenil Risk Calculator" },
            { label: "Parks 3-step utility" },
            { label: "Meridian power calculator" },
            { label: "Oblique cross cylinder calculator", permission: "pro" },
            { label: "Contact lens calculator", permission: "pro" },
          ],
        },
        {
          header: true,
          label: "Warm Fuzzy Feelings",
          items: [
            {
              label: "Support maintenance and development of EyeDock",
              permission: "pro",
            },
            {
              label: "Support complimentary accounts for students",
              permission: "pro",
            },
          ],
        },
      ],
    };
  },
  methods: {},
  computed: {},
};
</script>

<style scoped>
th,
td {
  padding: 2px 6px;
}
.cardTitle {
  background-color: #cee9fb;
}
</style>
